import { selectConditions, useSurveyStore } from "../../../../store";
import { ConditionHeader } from "../../components/header";
import { ConditionCard } from "./condition-card";
import { NoConditions } from "../no-conditions";

export const ConditionsList = () => {
  const conditions = useSurveyStore(selectConditions);
  const addNewCondition = useSurveyStore((state) => state.addNewCondition);
  const deleteCondition = useSurveyStore((state) => state.deleteCondition);
  const updateActiveConditionIdx = useSurveyStore(
    (state) => state.updateActiveConditionIdx
  );

  if (conditions.length === 0) return <NoConditions onAdd={addNewCondition} />;

  return (
    <div className="w-full flex flex-col min-h-0 h-full">
      <ConditionHeader
        editMode={false}
        onAdd={addNewCondition}
        onBack={() => {}}
      />
      <div className="py-6 px-4 overflow-y-auto flex-1">
        <div className="space-y-6 max-w-[732px] mx-auto">
          {conditions.map((condition, idx) => (
            <ConditionCard
              key={condition.internal_id}
              condition={condition}
              index={idx}
              onEdit={() => updateActiveConditionIdx(idx)}
              onDelete={() => deleteCondition(idx)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
